import React from 'react';

export const MainExistingMember = () => {

    return(
        <div className="center-container-holder">
            <div className="centered-container">
                <div className="center-holder">
                    <div className="title-holder">
                        <h1 className="title title-member"><b>Already in!</b></h1>
                    </div>
                    <div className="subtitle-holder">
                        <h3 className="subtitle subtitle-member">You already own Infinit, this waitlist is not for you.</h3>
                    </div>
                </div>
            </div>
        </div>
    )
};